import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TuiButton, TuiButtonX } from '@taiga-ui/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'pxc-cross-badge',
  imports: [TuiButton, TuiButtonX, TranslocoDirective],
  templateUrl: './cross-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrossBadgeComponent {
  readonly isActive = input(true);
  readonly remove = output();
}
